export interface ValidationErrors {
    email?: string;
    password?: string;
    phone?: string;
    fullname?: string;
  }
  
  export class AuthValidation {
    static validateEmail(email: string): string | undefined {
      if (!email) {
        return 'E-posta adresi boş bırakılamaz';
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        return 'Geçersiz e-posta formatı (örnek: ornek@mail.com)';
      }
      return undefined;
    }
  
    static validatePassword(password: string): string | undefined {
      if (!password) {
        return 'Şifre alanı boş bırakılamaz';
      }
    //   if (password.length < 5) {
    //     return 'Şifre 8 karakterden kısa olamaz';
    //   }
    //   if (!/[A-Z]/.test(password)) {
    //     return 'Şifreye en az bir büyük harf ekleyin';
    //   }
    //   if (!/[a-z]/.test(password)) {
    //     return 'Şifreye en az bir küçük harf ekleyin';
    //   }
    //   if (!/[0-9]/.test(password)) {
    //     return 'Şifreye en az bir rakam ekleyin';
    //   }
      return undefined;
    }
  
    static validatePhone(phone: string): string | undefined {
      if (!phone) {
        return 'Telefon numarası boş bırakılamaz';
      }
  
      // Remove spaces and other non-essential characters
      const cleanPhone = phone.replace(/[\s\-\(\)]/g, '');
  
      // Check if it starts with + and has at least one number after
      if (!/^\+\d+/.test(cleanPhone)) {
        return 'Alan kodu ile başlamalı (örnek: +90 için Türkiye)';
      }
  
      // Remove the + symbol for length check
      const numberOnly = cleanPhone.replace('+', '');
  
      // Most international phone numbers are between 7 and 15 digits
      // This includes country code
      if (numberOnly.length < 7 || numberOnly.length > 15) {
        return 'Geçerli bir telefon numarası girin (örnek format: +90 555 555 5555)';
      }
  
      // Check if it contains only numbers after the + sign
      if (!/^\+\d+$/.test(cleanPhone)) {
        return 'Telefon numarası sadece rakam içermeli';
      }
  
      return undefined;
    }
  
    static validateFullname(fullname: string): string | undefined {
      if (!fullname) {
        return 'Ad Soyad alanı boş bırakılamaz';
      }
      if (fullname.length < 2) {
        return 'Ad Soyad alanı 2 karakterden kısa olamaz';
      }
    //   if (!/^[a-zA-Z\s]*$/.test(fullname)) {
    //     return 'Ad Soyad alanı sadece harf içerebilir';
    //   }
      return undefined;
    }
  
    static validateLoginForm(email: string, password: string): ValidationErrors {
      const errors: ValidationErrors = {};
      
      const emailError = this.validateEmail(email);
      const passwordError = this.validatePassword(password);
      
      if (emailError) errors.email = emailError;
      if (passwordError) errors.password = passwordError;
      
      return errors;
    }
  
    static validateSignUpForm(
      email: string,
      password: string,
      phone: string,
      fullname: string
    ): ValidationErrors {
      const errors: ValidationErrors = {};
      
      const emailError = this.validateEmail(email);
      const passwordError = this.validatePassword(password);
      const phoneError = this.validatePhone(phone);
      const fullnameError = this.validateFullname(fullname);
      
      if (emailError) errors.email = emailError;
      if (passwordError) errors.password = passwordError;
      if (phoneError) errors.phone = phoneError;
      if (fullnameError) errors.fullname = fullnameError;
      
      return errors;
    }
  }